module.exports = __webpack_public_path__ + "img/no-content.5f4b9591.png";